<ng-template ngFor let-assetObj [ngForOf]="assetInfoObject.metadata">
  <ng-template [ngIf]="!assetObj.assetType || (assetObj.assetType && assetObj.assetType === asset.assetType)">
    <div
      class="dataset-entry flex row items-start"
      *ngIf="
        (!assetObj.customClients || (assetObj.customClients && assetObj.customClients === brandingKey)) &&
        ((assetObj.pipe && callPipe(assetObj)) || (!assetObj.directValue && asset[assetObj.formControlName]) || (assetObj.directValue && getComponentVariable(assetObj)))
      "
    >
      <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
      <div class="dataset-entry-value inline-block w-3/5 break-words" *ngIf="assetObj.pipe">
        <span class="mr-2">{{ callPipe(assetObj) }}</span>
      </div>
      <div class="dataset-entry-value inline-block w-3/5 break-words" *ngIf="!assetObj.pipe">
        <span class="mr-2" *ngIf="assetObj.directValue"> {{ getComponentVariable(assetObj) }} </span>
        <span class="mr-2" *ngIf="!assetObj.directValue && assetObj.formControlName !== 'brand'" [innerHTML]="asset[assetObj.formControlName] | optionsLabel: assetStatusLabels"></span>
        <span class="mr-2" *ngIf="!assetObj.directValue && assetObj.formControlName === 'brand'" [innerHTML]="asset[assetObj.formControlName].name"></span>
      </div>
    </div>
    <div class="dataset-entry flex row items-start" *ngIf="assetObj.propertyObject === 'metaData'">
      <ng-template [ngIf]="asset.customFields && asset['customFields'][assetObj.formControlName]">
        <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
        <div class="dataset-entry-value inline-block w-3/5 break-words">
          <span class="mr-2" [innerHTML]="asset['customFields'][assetObj.formControlName]"></span>
        </div>
      </ng-template>
      <ng-template [ngIf]="(!asset['customFields'] || !asset['customFields'][assetObj.formControlName]) && metadata[assetObj.formControlName]">
        <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
        <div class="dataset-entry-value inline-block w-3/5 break-words">
          <span class="mr-2" [innerHTML]="metadata[assetObj.formControlName]"></span>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ng-template>
